/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateOrgRateLimitRequestBody = {
  rateLimitEnabled?: boolean | undefined;
  rateLimitTimeWindow?: number | undefined;
  rateLimitMax?: number | null | undefined;
};

export type UpdateOrgRateLimitRequest = {
  orgId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody?: UpdateOrgRateLimitRequestBody | undefined;
};

/**
 * OK
 */
export type UpdateOrgRateLimitResponseBody = {
  id: string;
  rateLimitEnabled: boolean;
  rateLimitTimeWindow: number | null;
  rateLimitMax: number | null;
};

/** @internal */
export const UpdateOrgRateLimitRequestBody$inboundSchema: z.ZodType<
  UpdateOrgRateLimitRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  rateLimitEnabled: z.boolean().optional(),
  rateLimitTimeWindow: z.number().optional(),
  rateLimitMax: z.nullable(z.number().int()).optional(),
});
/** @internal */
export type UpdateOrgRateLimitRequestBody$Outbound = {
  rateLimitEnabled?: boolean | undefined;
  rateLimitTimeWindow?: number | undefined;
  rateLimitMax?: number | null | undefined;
};

/** @internal */
export const UpdateOrgRateLimitRequestBody$outboundSchema: z.ZodType<
  UpdateOrgRateLimitRequestBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgRateLimitRequestBody
> = z.object({
  rateLimitEnabled: z.boolean().optional(),
  rateLimitTimeWindow: z.number().optional(),
  rateLimitMax: z.nullable(z.number().int()).optional(),
});

export function updateOrgRateLimitRequestBodyToJSON(
  updateOrgRateLimitRequestBody: UpdateOrgRateLimitRequestBody,
): string {
  return JSON.stringify(
    UpdateOrgRateLimitRequestBody$outboundSchema.parse(
      updateOrgRateLimitRequestBody,
    ),
  );
}
export function updateOrgRateLimitRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdateOrgRateLimitRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateOrgRateLimitRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateOrgRateLimitRequestBody' from JSON`,
  );
}

/** @internal */
export const UpdateOrgRateLimitRequest$inboundSchema: z.ZodType<
  UpdateOrgRateLimitRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => UpdateOrgRateLimitRequestBody$inboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type UpdateOrgRateLimitRequest$Outbound = {
  orgId: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody?: UpdateOrgRateLimitRequestBody$Outbound | undefined;
};

/** @internal */
export const UpdateOrgRateLimitRequest$outboundSchema: z.ZodType<
  UpdateOrgRateLimitRequest$Outbound,
  z.ZodTypeDef,
  UpdateOrgRateLimitRequest
> = z.object({
  orgId: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => UpdateOrgRateLimitRequestBody$outboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function updateOrgRateLimitRequestToJSON(
  updateOrgRateLimitRequest: UpdateOrgRateLimitRequest,
): string {
  return JSON.stringify(
    UpdateOrgRateLimitRequest$outboundSchema.parse(updateOrgRateLimitRequest),
  );
}
export function updateOrgRateLimitRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateOrgRateLimitRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateOrgRateLimitRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateOrgRateLimitRequest' from JSON`,
  );
}

/** @internal */
export const UpdateOrgRateLimitResponseBody$inboundSchema: z.ZodType<
  UpdateOrgRateLimitResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  rateLimitEnabled: z.boolean(),
  rateLimitTimeWindow: z.nullable(z.number()),
  rateLimitMax: z.nullable(z.number()),
});
/** @internal */
export type UpdateOrgRateLimitResponseBody$Outbound = {
  id: string;
  rateLimitEnabled: boolean;
  rateLimitTimeWindow: number | null;
  rateLimitMax: number | null;
};

/** @internal */
export const UpdateOrgRateLimitResponseBody$outboundSchema: z.ZodType<
  UpdateOrgRateLimitResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgRateLimitResponseBody
> = z.object({
  id: z.string(),
  rateLimitEnabled: z.boolean(),
  rateLimitTimeWindow: z.nullable(z.number()),
  rateLimitMax: z.nullable(z.number()),
});

export function updateOrgRateLimitResponseBodyToJSON(
  updateOrgRateLimitResponseBody: UpdateOrgRateLimitResponseBody,
): string {
  return JSON.stringify(
    UpdateOrgRateLimitResponseBody$outboundSchema.parse(
      updateOrgRateLimitResponseBody,
    ),
  );
}
export function updateOrgRateLimitResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdateOrgRateLimitResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateOrgRateLimitResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateOrgRateLimitResponseBody' from JSON`,
  );
}
